export const NAV_LINKS = [
    { link: '/learn', intl_id: 'home.learn', isLearn: true },
    { link: '/play-online-chess', intl_id: 'home.play', isPlay: true },
    { link: '/watch', intl_id: 'home.watch', isWatch: true },
    // { link: '/results', intl_id: 'home.results', isResults: true },
    // { link: '/grand-chess-tour', intl_id: 'home.gct', isGCT: true },
    // { link: '/legacy', intl_id: 'home.legacy', isLegacy: true },
];
